// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2412h","fileBtn":"File_fileBtn__226rk","closeBtn":"File_closeBtn__1KrEd","fileSelected":"File_fileSelected__1KtP5","disabled":"File_disabled__EttWa"};